'use strict'

import $ from 'jquery';
import scrollTo from './scroll-to';

let dom = {};

const footnotes = {
  handleFootnotes(){
    if(!dom.$footnotesElement.length || !dom.$footnotesList.length || !dom.$footnotes.length){
      // If footnotesList or footnotes not exists > return
      return;
    }

    const self = this;

    // get the params from element node's data attribute
    let params = {};
    try {
      params = JSON.parse(dom.$footnotesElement.attr('data-js-params'));
    } catch(x) {
      // could not parse json
    }

    // each footnote
    dom.$footnotes.each(function(index){
      const footnoteNumber = index + 1;
      const footnoteId = 'footnote_'+footnoteNumber;
      const footnoteListItemId = 'footnotelistitem_'+footnoteNumber;
      const $footnote = $(this);
      const footnoteText = $footnote.html().replace(/[\[\]]/g, ''); // get footnote content and remove brackets
      const $footnoteTextWrap = $('<span></span>').addClass('footnote-text').html(footnoteText);

      const $listItem = $('<li tabindex="-1"></li>').attr('id', footnoteListItemId).append($footnoteTextWrap);
      $listItem.find('a').attr('target', '_blank'); // All links should open to new tab/window
      const listItemLinkText = (params.backToTop ? params.backToTop+' ' : '') + '(' + footnoteNumber + ') &#8593;';
      const $listItemLink = $('<a></a>').attr('href','#'+footnoteId).addClass('footnote-link').html(listItemLinkText).appendTo($listItem);
      dom.$footnotesList.append($listItem);

      const screenReaderHtml = params.footnote ? '<span class="sr-only">' + params.footnote + ':</span> ' : '';
      let $footnoteLink = $('<a></a>').attr('id', footnoteId).attr('href', '#'+footnoteListItemId).html(screenReaderHtml + '['+footnoteNumber+']');

      $listItemLink.add($footnoteLink).on('click', function(evt){
        evt.preventDefault();
        evt.stopPropagation();
        self.scrollTo($(this));
      });

      $footnote.empty().append($footnoteLink);
    })

    dom.$footnotesElement.css('display',''); // show the footnoteList

  },

  scrollTo($el) {
    const $target = $($el.attr('href'));
    let scrollOffsetTop = 10;
    if ($target.offset().top > window.scrollY) {
      scrollOffsetTop += dom.mobileHeaderMainBar.is(':visible') ? dom.mobileHeaderMainBar.height() : 0;
    }
    else {
      scrollOffsetTop += dom.mobileHeader.is(':visible') ? dom.mobileHeader.height() : 0;
    }
    scrollTo($target, {offsetTop: -scrollOffsetTop});
  },

  init(){
    const self = this;

    dom.$footnotesElement = $('.element-footnotes');
    dom.$footnotesList = $('ol.footnotes');
    dom.$footnotes = $('mark.footnote');
    dom.mobileHeaderMainBar = $('.mobile-header__main-bar');
    dom.mobileHeader = $('.mobile-header');

    self.handleFootnotes();
  }
}

module.exports = footnotes;
